var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0794 3.0969C12.9777 2.99114 12.8128 2.99114 12.7111 3.0969L3.13572 13.0553C3.03402 13.1611 3.03402 13.3326 3.13572 13.4383L11.9746 22.6307C12.0763 22.7365 12.2411 22.7365 12.3428 22.6307L21.9182 12.6723C22.0199 12.5665 22.0199 12.3951 21.9182 12.2893L13.0794 3.0969ZM11.6063 1.94785C12.3182 1.20749 13.4724 1.20749 14.1843 1.94785L23.0231 11.1402C23.735 11.8806 23.735 13.081 23.0231 13.8214L13.4477 23.7798C12.7358 24.5201 11.5816 24.5201 10.8697 23.7798L2.03087 14.5874C1.31897 13.847 1.31897 12.6466 2.03087 11.9063L11.6063 1.94785Z",
    fill: "#7C7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4194 2.09288C18.6266 2.09288 18.8253 2.17848 18.9719 2.33086L22.6547 6.16101C22.9598 6.47831 22.9598 6.99275 22.6547 7.31005L20.445 9.60818C20.14 9.92549 19.6453 9.92549 19.3402 9.6082C19.0351 9.2909 19.0351 8.77645 19.3402 8.45915L20.9975 6.73555L18.4194 4.05443L16.7622 5.778C16.4571 6.0953 15.9624 6.09531 15.6573 5.77801C15.3522 5.46071 15.3522 4.94626 15.6573 4.62896L17.867 2.33086C18.0135 2.17849 18.2122 2.09288 18.4194 2.09288Z",
    fill: "#7C7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59381 11.3749C8.59381 10.9262 8.94359 10.5624 9.37506 10.5624H15.6251C16.0565 10.5624 16.4063 10.9262 16.4063 11.3749C16.4063 11.8236 16.0565 12.1874 15.6251 12.1874H9.37506C8.94359 12.1874 8.59381 11.8236 8.59381 11.3749Z",
    fill: "#7C7B7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59381 14.6249C8.59381 14.1762 8.94359 13.8124 9.37506 13.8124H11.4584C11.8899 13.8124 12.2396 14.1762 12.2396 14.6249C12.2396 15.0736 11.8899 15.4374 11.4584 15.4374H9.37506C8.94359 15.4374 8.59381 15.0736 8.59381 14.6249Z",
    fill: "#7C7B7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8021 14.6249C13.8021 14.1762 14.1519 13.8124 14.5834 13.8124H15.6251C16.0565 13.8124 16.4063 14.1762 16.4063 14.6249C16.4063 15.0736 16.0565 15.4374 15.6251 15.4374H14.5834C14.1519 15.4374 13.8021 15.0736 13.8021 14.6249Z",
    fill: "#7C7B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredients);
export default __webpack_public_path__ + "static/media/ingredients.6e5a3eb2684840852cd0ca3d74c4557d.svg";
export { ForwardRef as ReactComponent };